import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";
import { LeadPatch } from "../pages/EditLeadDetailsPage";

export const sendEmployeeInvite = async (
  orgId: string,
  email: string,
  role: string,
) => {
  // {
  //   "email": "jane@example.com",
  //   "role": "staff"
  // }
  const data = {
    "email":email,
    "role": role,
  };
  let token = await getAuthToken();
  let headers;

  if(token){
    let header_token = "Bearer " + token.data;
    headers = {
        Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/invite/send/`;
    console.log('data', data);
    const response = await axios.post(endpoint, data, {headers});
    console.log('response', response);

    if (response.status === 201) {
      console.log("Invite sent successfully:", response.data);
      return { success: true, data: response.data };
    } else {
      console.error("Failed to send invite:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const employeeAcceptInvite = async (
  invite_token: string,
  orgId: string,
) => {
  // {
  //   "email": "jane@example.com",
  //   "role": "staff"
  // }
  const data = {
    "invite_token":invite_token
  };
  let token = await getAuthToken();
  let headers;

  if(token){
    let header_token = "Bearer " + token.data;
    headers = {
        Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/invite/accept/`;
    console.log('data', data);
    const response = await axios.post(endpoint, data, {headers});
    console.log('response', response);

    if (response.status === 200) {
      console.log("Invite accepted successfully:", response.data);
      return { success: true, data: response.data };
    } else {
      console.error("Failed to accept invite:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const getEmployees = async (organization_id: any) => {
    let token = await getAuthToken();
    try {
        if(token){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/employees`; 
            const response = await axios.get(endpoint,{ headers });
            console.log("Employees response", response);
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data retrieval failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the data:", error);
        return {"success":false, "data": undefined};
    }
};

export const getEmployeeData = async (organization_id: any, employee_id:any) => {
    let token = await getAuthToken();
    try {
        if(token){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/employees/${employee_id}/`; 
            const response = await axios.get(endpoint,{ headers });
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data retrieval failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the data:", error);
        return {"success":false, "data": undefined};
    }
};

export const getEmployeeDataMe = async (organization_id: any) => {
    let token = await getAuthToken();
    try {
        if(token){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/employees/me/`; 
            const response = await axios.get(endpoint,{ headers });
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data retrieval failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the data:", error);
        return {"success":false, "data": undefined};
    }
};

export const deleteEmployee = async (organization_id: any, employee_id: any) => {
    let token = await getAuthToken();
    try {
        if(token){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/employees/${employee_id}/`; 
            const response = await axios.delete(endpoint,{ headers });
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data deletion failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the data:", error);
        return {"success":false, "data": undefined};
    }
};

export const updateEmployee = async (
  organization_id: string,
  employee_id: string,
  updatedData: any
) => {
  let token = await getAuthToken();
  try {
    if (!token) return { success: false, data: "Token does not exist" };

    const headers = { Authorization: "Bearer " + token.data };

    try {
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/employees/${employee_id}/`;
      const response = await axios.patch(endpoint, updatedData, { headers });

      if (response.status >= 200 && response.status < 300) {
        return { success: true, data: response.data };
      } else {
        console.error("Employee update failed:", response.data);
        return { success: false, data: response.data };
      }
    } catch (error) {
      console.error("Error updating employee:", error);
      return { success: false, data: error };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};
